import React from 'react';

export const Forward = () => (
    <svg width="1em" height="1em" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.19 8.1">
        <g>
            <path d="M11.19,2.84L7.59,0V2.21H2.94C1.32,2.21,0,3.53,0,5.15s1.32,2.94,2.94,2.94h1.09v-1.25h-1.09c-.93,0-1.69-.76-1.69-1.69s.76-1.69,1.69-1.69H7.59v2.21l3.6-2.84Z"/>
        </g>
    </svg>
);
